import React from "react";

import { formatInteger } from "~/utils";
import { HealthSummary } from "../Shared";

interface StepsSummaryProps {
  filteredData: { x: Date | number; y: number }[];
  metadata: {
    avg: number;
  } | null;
  handlePrevious: () => void;
  handleNext: () => void;
  onDateSelect: (date: Date) => void;
  selectedDate: Date;
  selectedRange: string;
}

export const StepsSummary: React.FC<StepsSummaryProps> = ({
  filteredData,
  metadata,
  handlePrevious,
  handleNext,
  onDateSelect,
  selectedDate,
  selectedRange,
}) => {
  const getSummaryValues = (metadata: { avg: number } | null, _filteredData: { x: Date | number; y: number }[]) => [
    {
      label: "Total",
      value: formatInteger(metadata?.avg ?? 0),
      color: "#22c55e", // green-500
      unit: "steps",
    },
  ];

  return (
    <HealthSummary
      filteredData={filteredData}
      metadata={metadata}
      handlePrevious={handlePrevious}
      handleNext={handleNext}
      onDateSelect={onDateSelect}
      selectedDate={selectedDate}
      selectedRange={selectedRange}
      getSummaryValues={getSummaryValues}
    />
  );
};